import React, {useEffect, useState } from "react";
import { MdChevronLeft } from "react-icons/md";
import { MdChevronRight } from "react-icons/md";
import { FaClipboard } from "react-icons/fa";
import {
    SCHOOL_NAME,
    SCHOOL_DISTRICT,
    SCHOOL_LOCATION,
    SCHOOL_SUPPORT_EMAIL,
    SCHOOL_SUPPORT_NUMBER,
} from "../constants";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef } from "react";
import html2pdf from "html2pdf.js";


const data = [
    {
        id: 1,
        date: "2025-06-24",
        title: "Summer vacation extended until July 10th due to heatwave.",
        view: "View",
    },
    {
        id: 2,
        date: "2025-06-20",
        title: "Annual Sports Meet will be held on July 25th in the school ground.",
        view: "View",
    },
    {
        id: 3,
        date: "2025-06-18",
        title: "Class 10th result has been declared. Check your marks on the notice board.",
        view: "View",
    },
    {
        id: 4,
        date: "2025-06-15",
        title: "Weekly test for classes 6 to 12 scheduled for Monday, June 17.",
        view: "View",
    },
    {
        id: 5,
        date: "2025-06-10",
        title: "Science Exhibition registrations open till June 30.",
        view: "View",
    },
    {
        id: 6,
        date: "2025-06-05",
        title: "World Environment Day celebrated successfully with tree plantation drive.",
        view: "View",
    },
    {
        id: 7,
        date: "2025-05-30",
        title: "Parent-Teacher Meeting scheduled on June 7 at 9 AM.",
        view: "View",
    },
    {
        id: 8,
        date: "2025-05-25",
        title: "School will remain closed on May 28 for Buddha Purnima.",
    },
    {
        id: 9,
        date: "2025-06-05",
        title: "World Environment Day celebrated successfully with tree plantation drive.",
        view: "View",
    },
    {
        id: 10,
        date: "2025-05-30",
        title: "Parent-Teacher Meeting scheduled on June 7 at 9 AM.",
        view: "View",
    },
    {
        id: 11,
        date: "2025-05-25",
        title: "School will remain closed on May 28 for Buddha Purnima.",
    },
];
export default function NoticeBoard() {
    const [currentPage, setCurrentPage] = useState(1);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedNotice, setSelectedNotice] = useState(null);
    const noticeRef = useRef();
    const itemPerPage = 5;

    const currentIndex = (currentPage - 1) * itemPerPage;

    const endIndex = currentIndex + itemPerPage;
    const paginatedDataList = data.slice(currentIndex, endIndex);

// useEffect(() => {
//     const fetchNotices = async () => {
//       try {
//         const response = await axios.get("http://localhost:8000/api/v1/notice/all"); 
//         console.log(response.data.data)
//         setNotices(response.data.data); 
//       } catch (error) {
//         console.error("Failed to fetch notices", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotices();
//   }, []);



   const handleDownload = () => {
  const element = noticeRef.current;
  if (!element) return;

  // Temporarily hide buttons
  const elementsToHide = element.querySelectorAll('[data-pdf-exclude]');
  elementsToHide.forEach(el => el.style.display = 'none');

  const opt = {
    margin: 0.5,
    filename: `Notice_${selectedNotice?.date || "School"}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
  };

  html2pdf().set(opt).from(element).save().then(() => {
    // Show buttons again
    elementsToHide.forEach(el => el.style.display = 'flex');
  });
};


    return (
        <section className="section flex-col space-y-4">
            <div className="hide_scrollbar max-h-[700px] w-full overflow-auto rounded-md">
                <div className="bg-primary px-6 py-5 text-left text-xs font-semibold uppercase text-white">
                    <p className="flex items-center gap-4 text-white">
                        <FaClipboard size={22} />
                        notice board
                    </p>
                </div>
                <table className="w-full rounded-md">
                    {/* <thead>
                        <tr className="sticky top-0 bg-primary text-white">
                            {columns.map((column) => (
                                <th
                                    key={column}
                                    className="px-6 py-3 text-left text-xs font-semibold uppercase"
                                >
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead> */}
                    <tbody className="border">
                        {paginatedDataList.map((item, index) => (
                            <tr key={item.id}>
                                <td className="whitespace-nowrap px-6 py-4 text-sm">
                                    {item.date}
                                </td>
                                <td className="px-6 py-4 text-sm">
                                    {item.title}
                                </td>
                                <td className="whitespace-nowrap px-6 py-4 text-start">
                                    <button
                                        type="button"
                                        className="rounded-md bg-primary px-4 py-2 text-sm text-white transition duration-150"
                                        onClick={() => {
                                            setSelectedNotice(item);
                                            setOpenDialog(true);
                                        }}
                                    >
                                        {item.view || "View"}
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {paginatedDataList.length === 0 && (
                            <tr>
                                <td
                                    colSpan="3"
                                    className="w-full p-4 text-center"
                                >
                                    <p className="text-xs uppercase text-black sm:text-base">
                                        KEEP VISITING FOR LATEST UPDATES ON OUR
                                        SCHOOL ACTIVITIES.
                                    </p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {paginatedDataList.length > 0 && (
                <div className="flex justify-center">
                    <div className="space-x-4 text-sm">
                        <button
                            className="cursor-pointer rounded-lg bg-primary px-4 py-3 capitalize text-white shadow-lg transition-all duration-300 ease-in-out hover:bg-primary/80"
                            onClick={() => {
                                if (currentPage > 1 && data.length > 0)
                                    setCurrentPage(currentPage - 1);
                            }}
                        >
                            <MdChevronLeft />
                        </button>
                        <span>{currentPage}</span>
                        <button
                            className="cursor-pointer rounded-lg bg-primary px-4 py-3 capitalize text-white shadow-lg transition-all duration-300 ease-in-out hover:bg-primary/80"
                            onClick={() => {
                                if (
                                    currentPage <
                                        Math.ceil(data.length / itemPerPage) &&
                                    data.length > 0
                                ) {
                                    setCurrentPage(currentPage + 1);
                                }
                            }}
                        >
                            <MdChevronRight />
                        </button>
                    </div>
                </div>
            )}
     {openDialog && selectedNotice && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 pointer-events-auto">
    <div
      ref={noticeRef}
      className="w-[90%] max-w-2xl space-y-4 rounded-lg bg-white p-8 shadow-xl text-black"
    >
      <div className="text-center text-black">
        <h1 className="text-xl font-bold uppercase text-black">{SCHOOL_NAME}</h1>
        <p className="text-sm text-black">
          {SCHOOL_NAME} {SCHOOL_DISTRICT}
        </p>
        <hr className="my-2 border-t-2 border-black" />
        <h2 className="text-lg font-semibold underline text-black">NOTICE</h2>
      </div>

      <div className="text-right text-sm text-black">
        Date: <span className="text-black">{selectedNotice.date}</span>
      </div>

      <div className="text-left text-base text-black">
        <p className="text-black">{selectedNotice.title}</p>
        <br />
        <p className="text-black">
          All students and staff are requested to take necessary actions as per the
          above notice. For any queries, contact the school support below.
        </p>
      </div>

      <div className="mt-6 text-right text-black">
        <p className="font-medium text-black">Principal</p>
        <p className="text-sm text-black">
          {SCHOOL_NAME}, {SCHOOL_LOCATION}
        </p>
      </div>

      <div className="mt-4 border-t pt-2 text-left text-xs text-black">
        <p className="text-black">
          📞 Support: <span className="font-medium text-black">{SCHOOL_SUPPORT_NUMBER}</span>
        </p>
        <p className="text-black">
          📧 Email: <span className="font-medium text-black">{SCHOOL_SUPPORT_EMAIL}</span>
        </p>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '1rem',
        }}
        className="mt-6"
        ref={(el) => {
          if (el) {
            el.setAttribute("data-pdf-exclude", "true");
          }
        }}
      >
        <button
          className="rounded bg-gray-300 px-4 py-2 text-sm text-black hover:bg-gray-400"
          onClick={() => setOpenDialog(false)}
        >
          Close
        </button>
        <button
          className="rounded bg-primary px-4 py-2 text-sm text-white hover:opacity-90"
          onClick={handleDownload}
        >
          Download
        </button>
      </div>
    </div>
  </div>
)}

        </section>
    );
}
